import { ReportDisplayType, ReportGroupedByType } from "@src/components/deprecated/Report/Report";
import { DataObjectField } from "../../../../to-be-removed/LocalData/General/DataObjectField/DataObjectField";
import { DataObjectHelper } from "../../../../to-be-removed/LocalData/General/DataObjects/DataObjectHelper";
import { DataObjectHelpers } from "../../../../to-be-removed/LocalData/General/DataObjects/DataObjectHelpers";
import { t } from "i18next";

/**
 * Generates a title based on the report and its props
 */
export const getAutoTitle = (
  dataHelper: DataObjectHelper<any>,
  display: ReportDisplayType | undefined,
  groupedBy: ReportGroupedByType | undefined
) => {
  let title = "";

  if (display && display !== "countOfData") {
    if (display.calculation) {
      title += (display.calculation === "sum" ? t("main.theSumOf") : display.calculation === "average" ? t("main.theAverageOf") : "") + " ";
    }
    title +=
      (title ? display.field.title.toLowerCase() : display.field.title) +
      " " +
      t("main.on").toLowerCase() +
      " " +
      dataHelper.displayNamePlural().toLowerCase();
  } else if (display === "countOfData") {
    title += t("main.countOf") + " " + dataHelper.displayNamePlural().toLowerCase();
  } else {
    title += dataHelper.displayNamePlural();
  }

  if (groupedBy) {
    title += " " + t("main.groupedBy").toLowerCase() + " ";
    if (groupedBy instanceof DataObjectField) {
      title += groupedBy.title.toLowerCase();
    } else if (groupedBy) {
      title += groupedBy.field.title.toLowerCase();
      if (groupedBy.frequency) {
        title += " (" + t(`main.frequency_${groupedBy.frequency}`, groupedBy.frequency) + ")";
      }
    }
  }

  return title;
};

export const getDefaultHeaderKeys = (dataHelper: DataObjectHelper<any>) => {
  if (dataHelper.id() === "deviation") {
    return [DataObjectHelpers.deviation.title.key];
  }
  if (dataHelper.id() === "routine") {
    return [DataObjectHelpers.routine.title.key];
  }
  if (dataHelper.id() === "property") {
    return [DataObjectHelpers.property.name.key];
  }
  if (dataHelper.id() === "unit") {
    return [DataObjectHelpers.unit.name.key];
  }

  if (dataHelper.id().startsWith("collection")) {
    return ["name", "property"];
  }

  return [];
};

